import ModalHeaderPrimaryVariant from 'components/Modal/partials/ModalHeaderPrimaryVariant.component';
import withConnectedModal from 'components/Modal/withConnectedModal';
import { PendingSessionsModalSize } from './PendingSessionsGameModal.helpers';
import { PendingSessionsModalName } from './PendingSessionsModal.config';
import PendingSessionsGameModalBody from './PendingSessionsModalBody.component';

const PendingSessionsModal = withConnectedModal({
  modalName: PendingSessionsModalName,
  headerComponent: ModalHeaderPrimaryVariant,
  showOnMount: false,
  hideOnUnmount: false,
  bodyComponent: PendingSessionsGameModalBody,
  modifyTheme: PendingSessionsModalSize,
});

export default PendingSessionsModal;
